import { TableCellAttachments } from 'src/components/table-cell-attachments';

export default TableCellAttachments;
